import { Paper, Box, Typography, Divider } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

type ChartComponentProps = {
  title: string;
  options: any;
  lineData: any;
  height?: string;
  children?: React.ReactNode;
};

const Chart = function ({
  title,
  options,
  lineData,
  height,
  children,
}: ChartComponentProps): JSX.Element {
  return (
    <Paper variant="outlined" data-testid="chart-container">
      <Typography variant="h6" fontWeight={600} color="primary" paddingX={2} paddingY={1}>
        {title}
      </Typography>
      <Divider />
      <Box padding={2}>
        <Line options={options} data={lineData} height={height} />
        {children}
      </Box>
    </Paper>
  );
};

export default Chart;
